require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./kirthiga-reddypartone.json") })
        }
      }, "path---kirthiga-reddypartone");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---kirthiga-reddypartone!./.cache/json/kirthiga-reddypartone.json
// module id = 1160
// module chunks = 231608221292675